import { api, decodeVaultBlobResponse } from '../api/client';
import { resolvePasswordPolicy } from './passwordPoliciesApi';
import type { PasswordPolicyTarget, ValidatePasswordOptions } from './passwordPolicy';
import { rewrapVaultPassphrase } from './vault';

export async function changeVaultPassphrase(
  currentPassphrase: string,
  newPassphrase: string,
  target: PasswordPolicyTarget = 'vaultPassphrase',
  options: ValidatePasswordOptions = {},
): Promise<void> {
  const policy = await resolvePasswordPolicy(target);
  const blobResponse = await api.getVaultBlob();
  const blob = decodeVaultBlobResponse(blobResponse);
  const newVkWrapPassphrase = await rewrapVaultPassphrase(
    currentPassphrase,
    newPassphrase,
    blob.vaultSalt,
    blob.vkWrapPassphrase,
    blob.vaultBlob,
    blob.vaultVersion,
    policy,
    options,
  );

  await api.updateVkWrap(newVkWrapPassphrase);
}
